import { LABEL_FONT_SIZE } from '../../constants';
import { round } from '../../utils/utils';
import { IconPosition } from '../../interfaces';
export const ICON_SIZE = 24;
export const useLabelWithIcon = ({ definition: { width, height, text, icon, iconPosition, fontSize = LABEL_FONT_SIZE }, }) => {
    const midX = round(width / 2);
    const midY = round(height / 2);
    const { iconX, iconY, labelY } = getPositions({ midY, midX, icon, iconPosition, text, fontSize });
    return { midX, midY, iconX, iconY, labelY };
};
const getPositions = ({ midY, midX, icon, text, iconPosition, fontSize, }) => {
    let iconX, labelY, iconY;
    const iconSize = fontSize * 2;
    const textOffset = Math.ceil(fontSize / 2);
    const halfIconSize = fontSize;
    const iconOffset = halfIconSize;
    const centeringFix = Math.floor((iconOffset - textOffset) / 2);
    if (icon && text) {
        iconX = Math.round(midX - iconSize / 2);
        if (iconPosition === IconPosition.bottom) {
            labelY = Math.round(midY - textOffset - centeringFix);
            iconY = Math.round(midY - halfIconSize + iconOffset - centeringFix);
        }
        else {
            labelY = Math.round(midY + textOffset + centeringFix);
            iconY = Math.round(midY - halfIconSize - iconOffset + centeringFix);
        }
    }
    else if (icon) {
        iconY = Math.round(midY - iconSize / 2);
        iconX = Math.round(midX - iconSize / 2);
    }
    return { iconX, labelY, iconY };
};
//# sourceMappingURL=use-label-with-icon.js.map